module.exports = __webpack_public_path__ + "img/shigongdui60.7c23be97.png";